<template>
  <nuxt-link
    v-if="esAdmin"
    v-slot="{ href, navigate, isExactActive }"
    custom
    :to="{ name: 'workspace-registro-mg', params: { workspaceId: workspace.id } }"
  >
    <li class="tree__item" :class="{ active: isExactActive }">
      <div class="tree__action">
        <a :href="href" class="tree__link" @click="navigate">
          <i class="tree__icon baserow-icon-history"></i>
          <span class="tree__link-text">Registro de auditoría</span>
        </a>
      </div>
    </li>
  </nuxt-link>
</template>

<script>
/**
 * "Registro de auditoría" en la barra lateral del espacio, para su admin.
 * Enterprise pone aquí el suyo con candado; este lleva al registro del
 * espacio (quién borró, creó, invitó...), sin licencia.
 */
export default {
  name: 'RegistroSidebarEspacio',
  props: {
    workspace: { type: Object, required: true },
  },
  computed: {
    esAdmin() {
      return this.workspace.permissions === 'ADMIN'
    },
  },
}
</script>
